import typesData from './typesData'

const getActionsErrors = ({ actionType, actionData }) => {
  const actionsErrors = {}

  if (!actionType) return { actionType: true }

  if (!Object.keys(actionData).length) return { action: true }

  let action = ''
  let value = {}
  if (actionType === 'botAction') {
    action = actionData.eventType || ''
    value = actionData.eventData || {}
  }
  if (typesData.clientOperatorActionTypes.includes(actionType)) {
    action = actionData.actionSubtype || ''
    value = actionData.actionProperties || {}
  }
  switch (action) {
    case 'showAlternatives':
      if (!value.questionText || !value.alternativeList) actionsErrors[action] = true
      break
    case 'eventReassignConversation':
    case 'reassignConversation':
      if (!value.assignationType) actionsErrors[action] = { ...actionsErrors[action], assignationType: true }
      if (!value.removeAll && !value.brand) actionsErrors[action] = { ...actionsErrors[action], brand: true }
      if (!value.removeAll && !value.delegation) actionsErrors[action] = { ...actionsErrors[action], delegation: true }
      if (['operator', 'removeOperator'].includes(value.assignationType) && !value.removeAll && !value.operator) actionsErrors[action] = { ...actionsErrors[action], operator: true }
      break
    case 'COMMAND':
      if (!value.intentId) actionsErrors[action] = { ...actionsErrors[action], courtesy: true }
      if (!value.repetitionNumber) actionsErrors[action] = { ...actionsErrors[action], command: true }
      break
    case 'emitBotMessage':
      if (!value.content && !value.contentHtml && !value.buttons && !value.attachments) actionsErrors[action] = true
      break
    case 'dashboardComment':
    case 'dashboardNotification':
      if (!value.messageText) actionsErrors[action] = true
      break
    case 'oneShotProduct':
      if (!value.productFoundProcess) actionsErrors[action] = { ...actionsErrors[action], productFoundProcess: true }
      if (!value.productNotFoundProcess) actionsErrors[action] = { ...actionsErrors[action], productNotFoundProcess: true }
      break
    case 'processCapstone':
      if (!value.capstoneTimeout) actionsErrors[action] = { ...actionsErrors[action], timer: true }
      if (!value.capstoneCompleteProcess) actionsErrors[action] = { ...actionsErrors[action], completeProcess: true }
      if (!value.capstonePartialProcess) actionsErrors[action] = { ...actionsErrors[action], partialProcess: true }
      break
    case 'emitAutoBotMessage':
      if (!value.messageId) actionsErrors[action] = true
      break
    case 'addToManagementList':
    case 'deleteFromManagementList':
    case 'addUserToList':
    case 'removeUserFromList':
      if (!value.managementListId) actionsErrors[action] = true
      break
    case 'startProcess':
      if (!value.processId) actionsErrors[action] = true
      break
    case 'eventChangeState':
      if (!value.state) actionsErrors[action] = true
      break
    case 'changeState':
      if (!value.actionId) actionsErrors[action] = true
      break
    case 'eventSetCategory':
      if (!value.categoryId) actionsErrors[action] = true
      break
    case 'eventDeleteCategory':
      if (!value.categoryId) actionsErrors[action] = true
      break
    case 'changeSubject':
      if (!value.actionId) actionsErrors[action] = true
      break
    case 'INSULT':
    case 'IDK':
    case 'SUPPORT':
    case 'CANCEL':
    case 'UPDATE':
      if (!value.repetitionNumber) actionsErrors[action] = true
      break
    case 'eventSetLocale':
      if (!value.locale) actionsErrors[action] = true
      break
    case 'dataEntry':
      if (!value.variableName) actionsErrors[action] = true
      break
    case 'botTimer':
      if (!value.time || !value.unit) actionsErrors[action] = { ...actionsErrors[action], timer: true }
      if (!value.processId) actionsErrors[action] = { ...actionsErrors[action], process: true }
      break
    case 'TIMEOUT':
      if (!value.repetitionNumber) actionsErrors[action] = { ...actionsErrors[action], petition: true }
      if (!value.time || !value.unit) actionsErrors[action] = { ...actionsErrors[action], timer: true }
      break
    case 'FAQ':
      if (value.consoleId && (!value.categoryId || !value.categoryName)) actionsErrors[action] = { ...actionsErrors[action], virtualAssistantCategory: true }
      break
    case 'eventPaymentGateway': 
      if (!value.concept) actionsErrors[action] = true
      if (!value.question) actionsErrors[action] = true
      if (!value.amount) actionsErrors[action] = true
      break
    case 'GENERATIVE':
    case 'eventDeactivateMarketing':
    case 'eventActivateMarketing':
    case 'emitGenerativeResponse':
      break
    default:
      break
  }

  return actionsErrors
}

export default getActionsErrors
